import { parseElementFromString } from 'anodum';
import injectSiteSocialLinksSettings from './inject-site-social-links-settings';
import injectSiteEmailsSettings from './inject-site-emails-settings';
import constants from '../constants';

const injectSiteSettings = (options) => {
  const { variable, settingValue, setting, html, socialIcons } = options;

  let parsedElement = parseElementFromString(html, true);
  let targetElement = parsedElement.querySelector(variable.querySelector);

  if (!targetElement && parsedElement.matches(variable.querySelector)) {
    targetElement = parsedElement;
  }

  if (targetElement) {
    if (Array.isArray(settingValue)) {
      if (setting === constants.SOCIAL_LINKS && targetElement) {
        injectSiteSocialLinksSettings({
          settingValue,
          targetElement,
          variable,
          socialIcons,
        });
      } else if (setting === constants.EMAILS) {
        parsedElement = injectSiteEmailsSettings({
          settingValue,
          parsedElement,
        });
      } else {
        targetElement.innerHTML = settingValue.join('<br>');
      }
    } else if (typeof settingValue === 'string') {
      if (targetElement.nodeName === 'IMG') {
        targetElement.src = settingValue;
      } else if (targetElement.style.backgroundImage) {
        targetElement.style.backgroundImage = `url('${settingValue}')`;
        targetElement.style.backgroundSize = 'contain';
      } else {
        targetElement.innerHTML = settingValue;
      }
    } else if (setting === constants.BUSINESS_HOURS) {
      if (settingValue && settingValue.workingSchedule) {
        targetElement.innerHTML = settingValue.workingSchedule.join('<br>');
      }
    }
  }

  return parsedElement.outerHTML;
};

export default injectSiteSettings;
